import React from 'react';
import NgoModalPublicShopView from './NgoModalPublicShopView';
import { NgoListWithInfos } from '../../../../../../domain/ngo/ngoDescription';
import { useSelector } from 'react-redux';
import { AppState } from 'store/reducers';

const NgoDescription = () => {
  const { ong } = useSelector((state: AppState) => state.user);
  if (!ong) return <p>L'élève n'a pas encore choisi d'ONG.</p>;
  const {
    name,
    displayName,
    descriptions,
    actions,
    catchPhrases
  } = NgoListWithInfos.find(ngo => ngo.name === ong);
  return (
    <NgoModalPublicShopView
      name={name}
      displayName={displayName}
      descriptions={descriptions}
      actions={actions}
      catchPhrases={catchPhrases}
    />
  );
};

export default NgoDescription;
